module.exports = __webpack_public_path__ + "static/media/48362616_2308762485865596_1785316655388164096_o-thumb.e6d0f59a.jpg";